import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row;
  background-color: #ffffff;
  @media (max-width: 770px) {
    height: 100%;
    overflow-y: hidden;
    padding: 0;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;
  @media (max-width: 770px) {
    padding: 0;
  }
`;

export const SideBarContainer = styled.div`
  height: 100vh;
  min-width: 150px;
  background-image: linear-gradient(rgb(51, 139, 251), rgb(165, 64, 227));
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  display: flex;
  @media (max-width: 770px) {
    background-image: linear-gradient(rgb(165, 64, 227), rgb(165, 64, 227));
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 15vh;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    border-top-right-radius: 0px;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  @media (max-width: 770px) {
    width: 100%;
    // background-color: #000FFF;
  }
`;

export const NavigationContainer = styled.div`
  width: 100%;
  height: 80vh;
  padding: 0px 65px;
  overflow-y: scroll;

  @media (min-width: 770px) {
    display: grid;
    grid-template-columns: 60% 40%;
    width: 80%;
    height: 65vh;
  }

  @media (min-width: 770px) and (max-height: 650px) {
    height: 80vh !important;
  }

  @media (min-width: 770px) and (max-height: 600px) {
    height: 75vh !important;
  }

  @media (min-width: 770px) and (max-height: 575px) {
    height: 70vh !important;
  }

  @media (min-width: 770px) and (max-width: 1400px) {
    width: 100%;
    height: 65vh;
  }

  @media (max-width: 770px) {
    width: 100%;
    height: calc(100% - calc(18vh + 185px));
    padding: 30px 5px;
    background-color: #ffffff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }

  @media (max-width: 770px) and (max-height: 680px) {
    height: calc(100% - calc(32vh + 111px));
  }
`;

export const PageContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: #ffffff;
`;

export const DivisionCards = styled.div``;
